export default __webpack_public_path__ + "static/media/bird_meitdev.dc9019e2.gif";